import { createFileRoute } from "@tanstack/react-router";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import LightGallery from "lightgallery/react";
import { MINIGOLF_GALLERY_IMAGES } from "virtual:gallery-images";
import { useOptimizedImageArrayProps } from "@/components/image";
import {
  ScaffoldSection,
  ScaffoldSectionContainer,
  ScaffoldSectionContent,
  ScaffoldSectionHeader,
  ScaffoldSectionTitle,
} from "@/components/www/sections/scaffold";
import { seo } from "@/lib/seo";

export const Route = createFileRoute(
  "/_www/angebote/3d-schwarzlicht-minigolf/galerie"
)({
  component: RouteComponent,
  head: () =>
    seo({
      title: "Minigolf Galerie – Alte Papierfabrik Wuppertal",
      description:
        "Bilder aus dem 3D-Schwarzlicht Indoor Minigolf der Alten Papierfabrik Wuppertal – vier leuchtende Welten auf 18 Bahnen.",
      path: "/angebote/3d-schwarzlicht-minigolf/galerie",
      image: "/images/og/minigolf.jpg",
      imageAlt:
        "Leuchtende 3D-Schwarzlicht Minigolfbahn mit Astronauten-Wandmalerei",
    }),
});

function RouteComponent() {
  const optimizedImages = useOptimizedImageArrayProps(
    MINIGOLF_GALLERY_IMAGES,
    1920,
    1080
  );
  return (
    <ScaffoldSection className="py-20">
      <ScaffoldSectionContainer>
        <ScaffoldSectionHeader>
          <ScaffoldSectionTitle>Galerie</ScaffoldSectionTitle>
        </ScaffoldSectionHeader>
        <ScaffoldSectionContent>
          <LightGallery
            elementClassNames="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
            plugins={[lgThumbnail, lgZoom]}
            speed={500}
          >
            {optimizedImages.map((image) => (
              <img alt={image.src} key={image.src} src={image.src} />
            ))}
          </LightGallery>
        </ScaffoldSectionContent>
      </ScaffoldSectionContainer>
    </ScaffoldSection>
  );
}
